export const AVAILABLE_COURSES = [
  "Amazon Virtual Assistant",
  "Full Stack Digital Marketing & AI",
  "Shopify & Daraz Business",
  "Full Stack Graphic Designing & AI",
  "UI/UX Designing for Web & App",
  "WordPress Website Development",
  "React & Node.js Full Stack Development",
  "MERN Stack Web Development",
  "PHP Laravel Web Development",
  "Python Programming for Everyone",
  "Video Editing & Animation",
  "Artificial Intelligence (AI)",
  "Machine Learning & Data Science",
  "HunarmandSindh Cyber Security",
  "IELTS Preparation",
  "Freelancing Program",
  "Architectural Visualization with Blender 3D",
  "Textile Designing",
  "Digital Embroidery",
  "CGI Ads",
  "Cross platform Flutter App Development",
  "BlockChain Development",
  "Forex Trading",
  "Penetration Testing Web Hacking",
  "Advanced Google Ads",
  "Search Engine Optimization - SEO",
  "YouTube Monetization",
]; 